import Modal from 'components/common/Modal';
import SingleDatepicker from 'components/common/SingleDatePicker';
import { buttonStyle } from 'lib/styles/index';
import styled from 'styled-components';
import { useState } from 'react';
import useErrorMemoModal from 'hooks/error/useErrorMemoModal';

const ErrorMemoModal = ({ closeModal, id, done }) => {
  const [isEdit, setIsEdit] = useState(false);

  const { contents, date, memo, setContents, setDate, onChange, onUpdate } =
    useErrorMemoModal(id, closeModal);

  return (
    <Modal closeModal={closeModal}>
      <ErrorMemoModalBlock>
        <div className="memo-modal-header">
          <div className="memo-modal-title">
            {isEdit ? '메모 수정' : done ? '메모 조회' : '메모 등록'}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div className="memo-modal-header-date">처리 일자</div>
            {done && !isEdit ? (
              <div className="memo-modal-header-date">{memo?.doneAt}</div>
            ) : (
              <SingleDatepicker date={date} setDate={setDate} />
            )}
          </div>
        </div>
        {done && !isEdit ? (
          <div className="textarea">{memo?.memo}</div>
        ) : (
          <textarea value={contents} onChange={onChange} />
        )}
        <div className="btn-wrapper">
          <StyledBtn
            cancel
            onClick={() => {
              if (done && !isEdit) {
                setIsEdit(true);
                setContents(memo?.memo);
                setDate(new Date(memo?.doneAt));
                return;
              }
              closeModal();
            }}
          >
            {done && !isEdit ? '수정' : '취소'}
          </StyledBtn>
          <StyledBtn
            onClick={() => {
              if (!isEdit && done) {
                closeModal();
                return;
              }
              onUpdate();
            }}
          >
            {isEdit ? '완료' : done ? '닫기' : '등록'}
          </StyledBtn>
        </div>
      </ErrorMemoModalBlock>
    </Modal>
  );
};

export default ErrorMemoModal;

const ErrorMemoModalBlock = styled.div`
  width: 480px;
  padding: 2rem;

  .memo-modal-header {
    display: flex;
    justify-content: space-between;
  }

  .memo-modal-title {
    font-weight: bold;
  }

  .memo-modal-header-date {
    font-size: 12px;
    margin-right: 10px;
  }

  textarea,
  .textarea {
    width: 100%;
    height: 100px;
    margin-top: 1rem;
    padding: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    resize: none;
    font-size: 14px;
  }

  .btn-wrapper {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    button + button {
      margin-left: 1rem;
    }
  }
`;

const StyledBtn = styled.button`
  ${buttonStyle}
`;
